import LiteYouTubeEmbed from "react-lite-youtube-embed";
import videos from "../../settings/firmwareVideos.json";

export default function FirmwareReview() {
  return (
    <div className="firmwareContentSide">
      <div className="firmwareAdvantages">Обзоры прошивок смотрите тут</div>
      <div className="firmwareIframes">
        {videos.map((el, i) => (
          <LiteYouTubeEmbed
            key={i}
            id={el.id}
            title={el.title}
            wrapperClass={"yt-lite firmwareIframe"}
            playerClass={"lty-playbtn firmwareIframe-playbtn"}
          />
        ))}
      </div>
    </div>
  );
}
